// Get the container
const slideContainerLWLook1 = document.querySelector('.LWLook1');

// URLs for desktop images
const desktopImageUrlsLWLook1 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWDesktop_1.jpg?v=1731519294',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWDesktop_3.png?v=1731486896',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWDesktop_2.png?v=1731486392'
];

// URLs for mobile images
const mobileImageUrlsLWLook1 = [
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_1.jpg?v=1731519879',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_2.jpg?v=1731488806',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_3.jpg?v=1731488805',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_4.jpg?v=1731488806',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_5.jpg?v=1731488806',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_6.jpg?v=1731488805',
   'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/LWMobile_7.jpg?v=1731488805'
];

// Function to determine screen size and load appropriate images
function loadImagesLWLook1() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainerLWLook1.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        mobileImageUrlsLWLook1.forEach((url, index) => {
            const mobileImage = document.createElement('img');
            mobileImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            mobileImage.alt = `Mobile image ${index + 1}`;
            mobileImage.className = 'mobile-image-LWLook1';
            slideContainerLWLook1.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        desktopImageUrlsLWLook1.forEach((url, index) => {
            const desktopImage = document.createElement('img');
            desktopImage.src = `${url}?cache_buster=${Date.now()}`; // Force cache busting
            desktopImage.alt = `Desktop image ${index + 1}`;
            desktopImage.className = 'desktop-image-LWLook1';
            slideContainerLWLook1.appendChild(desktopImage);
        });
    }
}

// Throttle function to avoid excessive firing on resize
function throttle(func, delay) {
    let timeoutId;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func();
        }, delay);
    };
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImagesLWLook1();

    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', throttle(loadImagesLWLook1, 500));

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTimeLWLook1 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdownLWLook1() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTimeLWLook1 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown-LWLook1').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown-LWLook1').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdownLWLook1, 1000);
    }

    updateCountdownLWLook1();
});
